import { useFetchBillingRecord } from '@/api/hooks/useFetchBillingRecord'
import { AppHeader } from '@/components/AppHeader'
import { BillingCardInfo } from '@/components/BillingPage/BillingCardInfo'
import { BillingChargeList } from '@/components/BillingPage/BillingCharges'
import ProtectedPage from '@/components/ProtectedPage'
import { Screen } from '@/ui/core/screen'
import { Image } from 'expo-image'
import Images from '#/assets/images/image-map'

export default function BillingScreen() {
	const { billingRecord, isLoading } = useFetchBillingRecord()

	return (
		<ProtectedPage>
			<AppHeader />
			<Screen preset="fixed" className="flex flex-1">
				<BillingCardInfo primaryCard={billingRecord?.primaryCard} isLoading={isLoading} />
				<Image
					style={{ height: 16 }}
					source={Images.HorizontalDivider}
					contentFit="fill"
				/>
				<BillingChargeList charges={billingRecord?.charges} />
			</Screen>
		</ProtectedPage>
	)
}
